import React from 'react';
import DemoDashboard from '../demo/DemoDashboard';

const StandardDashboard = ({ user, onLogout }) => {
  return <DemoDashboard user={user} onLogout={onLogout} isDemoMode={false} routeNamespace="standard" />;
};

export default StandardDashboard;
